import { useEffect, useRef, useState } from 'react'
import { MdDeleteOutline, MdOutlineKeyboardArrowDown, MdArrowBack, MdRefresh } from 'react-icons/md'
import { RiDeleteBin6Line } from "react-icons/ri";
import { RiInboxFill } from 'react-icons/ri'
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import { showMessage, makeAjax, url, respStatus, dateFormat, formatDate } from '../../../helpers/global_helper'
import ReplyMessage from '../../user-pages/memo/reply-message/ReplyMessage'
import Popup from '../Popup'
import PropTypes from "prop-types";
import ActionLoader from '../../../pages/ActionLoader'
import { useDispatch } from 'react-redux'
import { getMemoCount } from '../../../store/actions'
import { withTranslation } from 'react-i18next';
import Loading from '../../games/Loading/Loading';

const Notification = (props) => {
    const dispatch = useDispatch();
    // Form initialization
    const initForm = {
        subject: "",
        message: "",
        username: "",
    };
    const InitFilterPage = {
        per_page: 30,
        page: 1,
    };
    const InitFilterPageOutbox = {
        per_page: 30,
        page: 1,
    };
    // Set & get data
    const [sendMsg, setSendMsg] = useState(false);
    const [formError, setFormError] = useState({});
    const [formData, setFormData] = useState(initForm);
    const [clientDetails, setClientDetails] = useState([]);
    const [playerDetails, setPalyerDetails] = useState([]);
    const [playerInboxMessage, setPlayerInboxMessage] = useState([]);
    const [playerOutboxMessage, setPlayerOutboxMessage] = useState({});
    const [playerOutboxPagination, setPlayerOutboxPagination] = useState(InitFilterPageOutbox);
    const [playerInboxPagination, setPlayerInboxPagination] = useState(InitFilterPage);
    const [singleFieldData, setSingleFieldData] = useState(InitFilterPageOutbox);
    const [singleFieldDataInbox, setSingleFieldInboxData] = useState(InitFilterPage);
    const [replyMessage, setReplyMessage] = useState(false);
    const [inMsg, setInMsg] = useState(true); // Controls which tab is active
    const [outMsg, setOutMsg] = useState(false);
    const [rowData, setRowData] = useState({});
    const [unreadMessageCount, setUnreadMessageCount] = useState(0);
    const [sendMessage, setSendMessage] = useState(false);
    const [durationPopup, setDurationPopup] = useState(false);
    const [newMessageCount, setNewMessageCount] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteId, setDeleteID] = useState([]);
    const [clickReadStatus, setClickReadStatus] = useState(true);
    const [latestMessage, setLatestMessage] = useState({});
    const [delete_popup, setDeletePopup] = useState(false);
    const [waitMessage, setWaitMessage] = useState({});
    const [loaderStatus, setLoader] = useState(false);
    // const [select_all, setSelectAll] = useState(false); // OLD SINGLE STATE - REMOVED
    const [selectAllInbox, setSelectAllInbox] = useState(false); // NEW STATE FOR INBOX
    const [selectAllOutbox, setSelectAllOutbox] = useState(false); // NEW STATE FOR OUTBOX
    const [multiCheck, setMultiCheck] = useState({});
    const [multiCheckOutbox, setMultiCheckOutbox] = useState({});
    const [showWarning, setWarning] = useState(false);
    const [showSuccess, setSuccess] = useState(false);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [count, setCount] = useState(0); // Assuming this is for inbox selections
    const [loading, setLoading] = useState(false);
    const [allSelect, setAllSelect] = useState(false) // Seemed unused, keeping if needed elsewhere
    const [spinning, setSpinning] = useState(false);
    // Scroll init
    let oldScrollY = 0;
    const inboxContainerRef = useRef(null);

    // Tenannt or client profile details based on domain
    const getClientDetails = (event) => {
        makeAjax(url.ADMIN_API.getClientDetails, formData, url.ADMIN_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setFormError(response.messages);
                    return;
                }
                setClientDetails(response.data);
            })
    }

    // Get player unread message count
    const getUnreadMessageCount = (event) => {
        makeAjax(url.MEMO_API.getPlayerUnreadMessageCount, [], url.MEMO_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setFormError(response.messages);
                    return;
                }
                setUnreadMessageCount(response.data);
            })
    }

    // Player outbox message list
    const getPlayerOutMessageList = (event) => {
        makeAjax(url.MEMO_API.listPlayerOutboxMessage, playerOutboxPagination, url.MEMO_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setPlayerOutboxMessage({}); // Clear message on error
                    return;
                }
                if (!inMsg) {
                    setNewMessageCount(true);
                }
                if (event == 'deleteMemo')
                    setNewMessageCount(false);
                setMultiCheckOutbox({});
                if (response.data && response.data.data) {
                    const sortedData = [...response.data.data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    setPlayerOutboxMessage({ ...response.data, data: sortedData });
                } else {
                    setPlayerOutboxMessage(response.data || {});
                }
            })
            .catch(() => {
                setPlayerOutboxMessage({});
            })
            .then(() => { // Simulate finally
                setLoading(false);
            });
    }

    // Player profile details
    const getPlayerDetails = (event) => {
        makeAjax(url.USER_API.getPlayerProfileDetail, formData, url.USER_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setFormError(response.messages);
                    return;
                }
                setPalyerDetails(response.data);
            })
    }

    // Send message
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!formData.subject || !formData.message) {
            let errors = {};
            if (!formData.subject) {
                errors.subject = ["Subject is required"];
                console.log("error", errors.subject);
            }
            if (!formData.message) {
                errors.message = ["Message is required"];
                console.log("error", errors.message);

            }
            setFormError(errors);
            setTimeout(() => {
                setFormError({});
            }, 5000);
            return;
        }
        setLoader(true);
        makeAjax(url.MEMO_API.playerComposeMessage, formData, url.MEMO_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    setLoader(false);
                    if (response.status != 'send_email_duration_error') {
                        setDurationPopup(true);
                        return;
                    }
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    setFormError(response.messages);
                    return;
                }
                setLoader(false);
                setFormData(initForm);
                setFormError({});
                showMessage(response);
                setSendMsg(false);
                setInMsg(true);
                setOutMsg(false);
            })
    };

    // Effect List
    useEffect(() => {
        getClientDetails();
        getPlayerDetails();
        getMessageList(page);
        getPlayerOutMessageList();
        getUnreadMessageCount();
        setClickReadStatus(true);
    }, []);

    const refreshMessage = (type) => {
        setLoading(true);
        if (type == 'inbox') {
            setCount(0);
            getUnreadMessageCount();
            setPlayerInboxMessage([]);
            getMessageList(1);
            setSelectAllInbox(false); // Reset Inbox Select All
            setSelectAllOutbox(false); // Also reset Outbox Select All when switching to inbox
            setAllSelect(false);
            for (let i = 0; i < playerInboxMessage?.length; i++) {
                selectedEntryObj[playerInboxMessage?.[i]['_id']] = false;
            }
            setMultiCheck(selectedEntryObj);
        } else if (type == 'outbox') {
            getPlayerOutMessageList();
            setMultiCheckOutbox({});
            setSelectAllInbox(false); // Reset Inbox Select All when switching to outbox
            setSelectAllOutbox(false); // Reset Outbox Select All
        }
        setSpinning(true);
        setTimeout(() => {
            setSpinning(false);
        }, 2000);
    }

    // Input event
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value, ['username']: playerDetails['username'] });
    }

    // On click reply open
    const replyMsg = (event, type) => {
        if (type === 'inbox') {
            makeAjax(url.MEMO_API.playerUpdateMessageStatus, { _id: event._id }, url.MEMO_MS_EXT)
                .then(response => {
                    if (response.status != respStatus['SUCCESS']) {
                        if (response.code != 'validation_error') {
                            showMessage(response);
                        }
                        setFormError(response.messages);
                        return;
                    }
                    getUnreadMessageCount();
                    dispatch(getMemoCount());
                    props.getNotificationCount();
                })
        }
        setCount(0);
        setReplyMessage(true)
        setRowData(event);
        setWaitMessage(`${props.t('you_have_just_sended_the_memo_please_wait_for_the_two_minutes_to_send_another_memo')}.${props.t('thank_you')}`);
    }

    // On click reply close
    const replyMsgClose = () => {
        setReplyMessage(false);
        setRowData({});
        setSendMessage(true);
        setInMsg(true);
        setOutMsg(false);
        setClickReadStatus(true);
        setSelectAllInbox(false); // Reset inbox select all when closing reply
        setSelectAllOutbox(false); // Reset outbox select all when closing reply
    }

    // Onclick incoming mesage tab
    const updateIncommingMessage = (event) => {
        setSingleFieldInboxData(InitFilterPage);
        setPlayerInboxPagination(InitFilterPage);
        setPage(1);
        setInMsg(true);
        setOutMsg(false);
        setSendMsg(false);
        setReplyMessage(false);
        setRowData({});
        setSelectAllInbox(false); // Reset Inbox Select All
        setSelectAllOutbox(false); // Reset Outbox Select All
        setClickReadStatus(true);
        // getMessageList(1);
        refreshMessage('inbox');
    }

    // Onclick outgoing mesage tab
    const updateOutgoingMessage = (event) => {
        setInMsg(false);
        setOutMsg(true);
        setSendMsg(false);
        setReplyMessage(false);
        setRowData({});
        setSelectAllInbox(false); // Reset Inbox Select All
        setSelectAllOutbox(false); // Reset Outbox Select All
        getPlayerOutMessageList();
    }

    const handleCreateMessage = () => {
        setSendMsg(true);
        setInMsg(false);
        setOutMsg(false);
        setReplyMessage(false);
    }

    // Set false popup
    const handlePopup = () => {
        setSendMessage(false);
        setDurationPopup(false);
        setNewMessageCount(false);
        setShowDelete(false);
        setWarning(false);
        setSuccess(false);
    }

    // Set true email duaration validation popup
    const emailDuration = () => {
        setDurationPopup(true);
    }

    // Set true email duaration validation popup
    const handleEmailDurationPopupOn = () => {
        setDurationPopup(false);
    }

    // Close delete popup
    const deleteMessageConfirm = () => {
        setShowDelete(false)
    }

    // Pagination
    const gotoInboxListing = () => {
        setReplyMessage(false);
        setInMsg(true);
        setOutMsg(false);
        setSendMsg(false);
        getMessageList(page);
    }

    // Multiselect inbox array
    let selectedEntryObj = {};
    let allSiteData = {};
    useEffect(() => {
        selectedEntryObj = {};
        allSiteData = {};
        if (typeof playerInboxMessage.data != 'undefined') {
            for (let i = 0; i < playerInboxMessage.data.length; i++) {
                selectedEntryObj[playerInboxMessage.data[i]['_id']] = false;
                allSiteData[playerInboxMessage.data[i]['_id']] = JSON.parse(JSON.stringify(playerInboxMessage.data[i]));
            }
            setMultiCheck(selectedEntryObj);
        }
    }, [playerInboxMessage]);

    // Multiselect outbox array
    let selectedOutboxEntryObj = {};
    let allSiteOutboxData = {};
    useEffect(() => {
        selectedOutboxEntryObj = {};
        allSiteOutboxData = {};
        if (typeof playerOutboxMessage.data != 'undefined') {
            for (let i = 0; i < playerOutboxMessage.data.length; i++) {
                selectedOutboxEntryObj[playerOutboxMessage.data[i]['_id']] = false;
                allSiteOutboxData[playerOutboxMessage.data[i]['_id']] = JSON.parse(JSON.stringify(playerOutboxMessage.data[i]));
            }
            setMultiCheckOutbox(selectedOutboxEntryObj);
        }
    }, [playerOutboxMessage]);

    // Check / uncheck records
    const checkUnCheckMe = (_id, type) => {
        let check = {};
        if (type == 'inbox') {
            if (check[_id] = !multiCheck[_id]) {
                setCount((prevCount) => prevCount + 1)
            } else {
                setCount((prevCount) => prevCount - 1)
            }
            check[_id] = !multiCheck[_id];
            setMultiCheck({ ...multiCheck, ...check });
        }
        if (type == 'outbox') {
            check[_id] = !multiCheckOutbox[_id];
            setMultiCheckOutbox({ ...multiCheckOutbox, ...check });
        }
    }

    // Check / uncheck records - Updated for separate states
    const selectAllMobile = (type) => {
        if (type == 'inbox') {
            // Use the correct data source for inbox
            const currentData = playerInboxMessage?.data || playerInboxMessage;
            for (let i = 0; i < currentData?.length; i++) {
                selectedEntryObj[currentData[i]['_id']] = !selectAllInbox; // Use inbox state
            }
            setMultiCheck(selectedEntryObj);
            // Update count only for inbox selection
            setCount(selectAllInbox ? 0 : Object.keys(selectedEntryObj).length);
            setSelectAllInbox(!selectAllInbox); // Update inbox state
        }
        if (type == 'outbox') {
            const currentData = playerOutboxMessage?.data; // Outbox data is always in .data
            for (let i = 0; i < currentData?.length; i++) {
                selectedOutboxEntryObj[currentData[i]['_id']] = !selectAllOutbox; // Use outbox state
            }
            setMultiCheckOutbox(selectedOutboxEntryObj);
            setSelectAllOutbox(!selectAllOutbox); // Update outbox state
        }
    }

    // Select all records - Updated for separate states
    const selectAll = (type) => {
        if (type == 'inbox') {
            const currentData = playerInboxMessage?.data; // Inbox data is in .data
            for (let i = 0; i < currentData?.length; i++) {
                selectedEntryObj[currentData[i]['_id']] = !selectAllInbox; // Use inbox state
            }
            setMultiCheck(selectedEntryObj);
            setSelectAllInbox(!selectAllInbox); // Update inbox state
        }
        if (type == 'outbox') {
            const currentData = playerOutboxMessage?.data; // Outbox data is in .data
            for (let i = 0; i < currentData?.length; i++) {
                selectedOutboxEntryObj[currentData[i]['_id']] = !selectAllOutbox; // Use outbox state
            }
            setMultiCheckOutbox(selectedOutboxEntryObj);
            setSelectAllOutbox(!selectAllOutbox); // Update outbox state
        }
    }

    // Click on delete button
    const deleteMe = (v, id) => {
        let memoId = [];
        if (v == 'inbox') {
            if (id) {
                memoId.push(id);
            }
            else {
                let keys = Object.keys(multiCheck);
                for (let i = 0; i < keys.length; i++) {
                    if (multiCheck[keys[i]]) {
                        memoId.push(keys[i]);
                    }
                }
            }
        }
        if (v == 'outbox') {
            if (id) {
                memoId.push(id);
            } else {
                let keys = Object.keys(multiCheckOutbox);
                for (let i = 0; i < keys.length; i++) {
                    if (multiCheckOutbox[keys[i]]) {
                        memoId.push(keys[i]);
                    }
                }
            }
        }
        if (!memoId.length) {
            setWarning(true);
            setFormError({})
            return;
        }
        setDeleteID(memoId);
        setShowDelete(true);
        // Reset the correct "Select All" state when delete popup opens
        if (v === 'inbox') {
            setSelectAllInbox(false);
            setCount(0);
        } else if (v === 'outbox') {
            setSelectAllOutbox(false);
            // Count is only for inbox, so no need to reset here
        }
    }

    // Confirm deleting records
    const deleteConfirmMessage = () => {
        let payload = {
            _id: deleteId,
        }
        setReplyMessage(false);
        makeAjax(url.MEMO_API.deletePlayerMessage, payload, url.MEMO_MS_EXT)
            .then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    showMessage(response);
                    return;
                }
                setNewMessageCount(false);
                setShowDelete(false);
                setSuccess(true);
                setMultiCheck({});
                setMultiCheckOutbox({}); // Clear outbox selections too after a delete action
                setDeleteID([]);
                getUnreadMessageCount();
                dispatch(getMemoCount());
                props.getNotificationCount()
                dispatch(getMemoCount());
                getMessageList(1, 'deleteMemo');
                getPlayerOutMessageList('deleteMemo');
            })
    }

    // Fetch game data
    const fetchMessageData = (nextPage, event) => {
        return new Promise((resolve, reject) => {
            makeAjax(
                url.MEMO_API.listPlayerInboxMessage,
                { 'page': nextPage, 'per_page': 10 },
                url.MEMO_MS_EXT
            ).then(response => {
                if (response.status != respStatus['SUCCESS']) {
                    if (response.code != 'validation_error') {
                        showMessage(response);
                    }
                    showMessage(response);
                    reject('API Error');
                    return;
                }
                if (event == 'deleteMemo')
                    setNewMessageCount(false);
                setClickReadStatus(false);
                if (clickReadStatus) {
                    setClickReadStatus(true);
                }
                resolve({
                    data: response?.data?.data || [],
                    currentPage: response?.data?.current_page || 1,
                    lastPage: response?.data?.last_page || 1,
                });
            }).catch(error => {
                reject(error);
            });
        });
    };

    // Get msg list
    const getMessageList = async (nextPage, event) => {
        try {
            if (event == 'deleteMemo')
                setPlayerInboxMessage([]);
            if (lastPage == 0 || nextPage <= lastPage) {
                const response = await fetchMessageData(nextPage, event);
                setPage(nextPage + 1);
                setLastPage(response.lastPage);
                if (event === "runInLoop") {
                    setPlayerInboxMessage(response.data)
                    props.getNotificationCount()
                }
                else {
                    setPlayerInboxMessage((prevRecords) => [...prevRecords, ...response.data]);
                }
            }
        } catch (error) {
            console.error('Error fetching records:', error);
        } finally {
            setLoading(false);
        }
    };

    // On scroll game load - Updated to use inbox-specific state
    let debounceTimer;
    const handleScroll = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const container = inboxContainerRef.current;
            if (!container) return; // Add null check
            const distanceFromBottom = container.scrollHeight - (container.scrollTop + container.clientHeight);
            const threshold = 50;

            // Only apply select all logic if inbox is active and select all is true
            if (inMsg && selectAllInbox) { // Use selectAllInbox and check inMsg
                const currentData = playerInboxMessage?.data || playerInboxMessage; // Handle potential array vs object
                for (let i = 0; i < currentData?.length; i++) {
                    selectedEntryObj[currentData?.[i]['_id']] = selectAllInbox;
                }
                // Update count only if selecting, clear if unselecting (though scroll shouldn't unselect)
                if (selectAllInbox && Object.keys(selectedEntryObj).length) {
                    setCount(Object.keys(selectedEntryObj).length);
                }
                setMultiCheck(selectedEntryObj);
            }

            if (distanceFromBottom < threshold) {
                setLoading(true);
                getMessageList(page);
            }
        }, 450);
    };

    // On scroll game load - Updated dependency array
    useEffect(() => {
        const container = inboxContainerRef.current;
        container?.addEventListener('scroll', handleScroll);
        return () => {
            container?.removeEventListener('scroll', handleScroll);
        };
    }, [page, selectAllInbox]); // Removed select_all, added selectAllInbox

    return (
        <>
            <div className="user-div">
                {sendMsg ? (
                    <div className="title-box title-box-color">
                        <h3 className="text-create-message">{props.t('create_message')}</h3>
                    </div>
                ) : (
                    <div className="notification-header d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center w-100">
                        <div className="notification-tabs d-flex text-white gap-2 gap-md-3 align-items-center mb-2 mb-md-0 w-100">
                            <div
                                role='button'
                                className={`tab-btn nav-pills rounded px-2 px-md-3 py-2 flex-shrink-1 text-nowrap ${inMsg ? 'border-start border-end border-top border-bottom border-transparent' : 'border-start border-end border-top border-bottom border-secondary'}`}
                                onClick={updateIncommingMessage}
                                style={{ fontSize: 'clamp(0.7rem, 2.5vw, 1rem)', color: inMsg ? "#6e1a99" : "#6c757d" }}
                            >
                                <span className="d-none d-sm-inline">{props.t('notifications')}</span>
                                <span className="d-inline d-sm-none">Notification</span>
                                {' '}
                                <span role='button' className="count">{unreadMessageCount ? unreadMessageCount : 0}</span>
                            </div>
                            <div
                                role='button'
                                className={`tab-btn nav-pills nav-link rounded px-2 px-md-3 py-2 flex-shrink-1 text-nowrap ${outMsg ? 'border-start border-end border-top border-bottom border-transparent' : 'border-start border-end border-top border-bottom border-secondary'}`}
                                onClick={updateOutgoingMessage}
                                style={{ fontSize: 'clamp(0.7rem, 2.5vw, 1rem)', color: outMsg ? "#6e1a99" : "#6c757d" }}
                            >
                                <span className="d-none d-sm-inline">{props.t('outbox')}</span>
                                <span className="d-inline d-sm-none">Outbox</span>
                                {' '}
                                <span className="count out-box">{playerOutboxMessage?.data?.length || 0}</span>
                            </div>
                            <button
                                className="create-message-btn p-2 ms-md-0 flex-shrink-0"
                                onClick={handleCreateMessage}
                                style={{ fontSize: 'clamp(0.7rem, 2.5vw, 1rem)' }}
                            >
                                <span className="d-none d-sm-inline">{props.t('create_message')}</span>
                                <span className="d-inline d-sm-none">Create Message</span>
                            </button>
                        </div>
                        <div className="d-flex align-items-center justify-content-start justify-content-md-end w-100 w-md-auto">
                            {!replyMessage &&
                                <p className='mass-spin m-0 me-3 ' onClick={() => { refreshMessage(inMsg ? 'inbox' : 'outbox') }}>
                                    <MdRefresh
                                        className={`spin-button ${spinning ? "spin" : ""}`}
                                    /> {props.t('refresh')}
                                </p>
                            }
                        </div>
                    </div>
                )}
            </div>
            <div className='memo'>
                <div className="memo-box">
                    <div className="indox-div">
                        {/* Inbox Message Option - Show only when inbox is active */}
                        <div className={`message-option ${inMsg && !replyMessage ? 'active' : ''}`}>
                            {
                                inMsg && !replyMessage && (
                                    <>
                                        <span>
                                            <p className='mass-delete' onClick={() => { selectAllMobile('inbox') }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAllInbox} // Use inbox state
                                                    onChange={() => { }}
                                                    onClick={() => { selectAllMobile('inbox') }}
                                                />
                                                <span></span>
                                                <p className='noti-select'>{props.t('select_all')}</p>
                                            </p>
                                        </span>
                                        <span className="select-count">
                                            <p>{count > 0 && <span>{count} {props.t('selected')}</span>}</p>
                                            <p className='mass-delete' onClick={() => { deleteMe('inbox', rowData?._id) }}>
                                                {props.t('wipe')}
                                            </p>
                                        </span>
                                    </>
                                )
                            }
                            {
                                inMsg && replyMessage && (
                                    <>
                                        <div className='backarr' onClick={updateIncommingMessage}><MdArrowBack /></div>
                                        <span className="select-count">
                                            <p className='mass-delete' onClick={() => { deleteMe('inbox', rowData?._id) }}>
                                                {props.t('wipe')}
                                            </p>
                                        </span>
                                    </>
                                )
                            }
                        </div>

                        {/* Outbox Message Option - Show only when outbox is active */}
                        <div className={`message-option ${outMsg && !replyMessage ? 'active' : ''}`}>
                            {
                                outMsg && !replyMessage && (
                                    <>
                                        <span>
                                            <p className='mass-delete' onClick={() => { selectAllMobile('outbox') }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAllOutbox} // Use outbox state
                                                    onChange={() => { }}
                                                    onClick={() => { selectAllMobile('outbox') }}
                                                />
                                                <span></span>
                                                <p className='noti-select'>{props.t('select_all')}</p>
                                            </p>
                                        </span>
                                        <span className="select-count">
                                            {/* Note: 'count' state is likely only used for inbox, so it might not be relevant here */}
                                            {/* <p>{count > 0 && <span>{count} {props.t('selected')}</span>}</p> */}
                                            <p className='mass-delete' onClick={() => { deleteMe('outbox', rowData?._id) }}>
                                                {props.t('wipe')}
                                            </p>
                                        </span>
                                    </>
                                )
                            }
                            {
                                outMsg && replyMessage && (
                                    <>
                                        <div className='backarr' onClick={updateOutgoingMessage}><MdArrowBack /></div>
                                        <span className="select-count">
                                            <p className='mass-delete' onClick={() => { deleteMe('outbox', rowData?._id) }}>
                                                {props.t('wipe')}
                                            </p>
                                        </span>
                                    </>
                                )
                            }
                        </div>

                        <div className="table-div">
                            {(sendMsg === true) ?
                                <form className='create-message p-3 text-white'>
                                    <div className="row">
                                        <label htmlFor="recipient" className="col-sm-2 col-form-label create-label form-label text-form_text">{props.t('to')} :</label>
                                        {/* <div className="col-sm-10">
                                            <input className='form-control text-white' style={{ background: '#00000033' }} type="text" value={clientDetails.domain_name} readOnly />
                                        </div> */}
                                        <div className='d-flex flex-column col-sm-10 p-0'>
                                            <input
                                                type="text"
                                                value={clientDetails.domain_name}
                                                readOnly
                                                style={{color: "var(--vs--text-title)"}}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <label htmlFor="subject" className="col-sm-2 col-form-label create-label form-label text-form_text">{props.t('subject')} :</label>
                                        {/* <div className="col-sm-10">
                                            <input className='form-control text-white' required style={{ background: '#00000033', color: 'white'}} type="text" placeholder={props.t('subject')} value={formData.subject} name="subject" onChange={handleChange} />
                                        </div> */}
                                        <div className='d-flex flex-column col-sm-10 p-0'>
                                            <input
                                                type='text'
                                                value={formData.subject}
                                                name="subject" onChange={handleChange}
                                                placeholder={props.t('subject')}
                                            />
                                            {formError?.subject && (
                                                <span className="text-danger create-err-msg">{formError?.subject[0]}</span>
                                            )}
                                        </div>

                                    </div>
                                    <div className="row">
                                        <label htmlFor="message" className="col-sm-2 col-form-label create-label form-label text-form_text">{props.t('message')} :</label>
                                        {/* <div className="col-sm-10">
                                            <textarea className='form-control' required style={{ background: '#00000033', color: 'white' }} rows="5" placeholder={props.t('message')} value={formData.message} name='message' onChange={handleChange}>
                                            </textarea>
                                        </div> */}
                                        <div className='d-flex flex-column col-sm-10 p-0'>
                                            <textarea
                                                type='text'
                                                placeholder={props.t('message')}
                                                value={formData.message}
                                                name='message'
                                                onChange={handleChange} />
                                            {formError?.message && (
                                                <span className="text-danger create-err-msg">{formError?.message[0]}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="create-send-btn">
                                        <BsFillArrowLeftCircleFill onClick={gotoInboxListing} style={{ cursor: 'pointer' }} size={30} className='arrow-message-icon' />
                                        <ActionLoader label={props.t('send')} loaderClass={'send-button'} showLoader={loaderStatus} onClick={handleSubmit} />
                                    </div>
                                </form>
                                : (replyMessage === true) ?
                                    <>
                                        <ReplyMessage replyMsgClose={replyMsgClose} gotoInboxListing={gotoInboxListing} emailDuration={emailDuration} rowData={rowData} type={inMsg} />
                                    </>
                                    :
                                    <>
                                        <table>
                                            <thead>
                                                {
                                                    inMsg && // Show header only for inbox
                                                    <>
                                                        <tr>
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectAllInbox} // Use inbox state
                                                                    onChange={() => { }}
                                                                    onClick={() => { selectAll('inbox') }}
                                                                />
                                                            </th>
                                                            <th className='cusWidth1'>{props.t('operator')}</th>
                                                            <th className='cusWidth'>{props.t('subject')}</th>
                                                            <th className='cusWidth1'>{props.t('date')}/{props.t('time')}</th>
                                                            <th className='cusWidth1'><p className='mass-delete' onClick={() => { deleteMe('inbox') }}>
                                                                {props.t('delete_all')}<MdDeleteOutline />
                                                            </p></th>
                                                        </tr>
                                                    </>
                                                }
                                                {
                                                    outMsg && // Show header only for outbox
                                                    <>
                                                        <tr>
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectAllOutbox} // Use outbox state
                                                                    onChange={() => { }}
                                                                    onClick={() => { selectAll('outbox') }}
                                                                />
                                                            </th>
                                                            <th className='cusWidth1'>{props.t('to')}</th>
                                                            <th className='cusWidth'>{props.t('subject')}</th>
                                                            <th className='cusWidth1'>{props.t('date')}/{props.t('time')}</th>
                                                            <th className='cusWidth1'><p className='mass-delete' onClick={() => { deleteMe('outbox') }}>
                                                                {props.t('delete_all')}<MdDeleteOutline />
                                                            </p></th>
                                                        </tr>
                                                    </>
                                                }
                                            </thead>
                                            {inMsg &&
                                                <tbody>
                                                    <div className='inboxscroll' ref={inboxContainerRef}>
                                                        {
                                                            typeof playerInboxMessage != 'undefined' && playerInboxMessage.length > 0 ? <>
                                                                {playerInboxMessage.map((v, i) =>
                                                                    <tr key={i} style={!v.status ? { background: 'var(--vs-card-hover)', margin: "5px 0px" } : { background: 'var(--vs-card-bg2)', margin: "5px 0px" }}>
                                                                        <td className='note-player'>
                                                                            <label>
                                                                                <input type="checkbox" id="checkbor_arr" name="checkbor_arr" checked={multiCheck[v._id]} onChange={() => { }} onClick={() => { checkUnCheckMe(v._id, 'inbox') }} />
                                                                                <span></span>
                                                                            </label>
                                                                        </td>
                                                                        <tr className='democlass'>
                                                                            <td className='zero' onClick={() => replyMsg(v, 'inbox')}>{v.domain_name}</td>
                                                                            {
                                                                                !v.status && <td
                                                                                    onClick={() => { replyMsg(v, 'inbox'); }} className='subject-len zero msgreply'>{v.subject}
                                                                                </td>
                                                                            }
                                                                            {
                                                                                v.status && <td
                                                                                    onClick={() => replyMsg(v, 'inbox')} className='subject-len'>{v.subject}</td>
                                                                            }
                                                                        </tr>
                                                                        <tr className='democlass'>
                                                                            <td className='memodate' onClick={() => replyMsg(v, 'inbox')}>
                                                                                {formatDate(v?.created_at)}
                                                                            </td>
                                                                            <td className='memodate'>
                                                                                <span onClick={() => deleteMe('inbox', v?._id)}>
                                                                                    <RiDeleteBin6Line />
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tr>
                                                                )}
                                                            </> :
                                                                <>
                                                                    {!loading && <>
                                                                        {props.t('no_memo_found')}
                                                                    </>}
                                                                </>
                                                        }
                                                    </div>
                                                </tbody>
                                            }
                                            {outMsg &&
                                                <tbody>
                                                    <div className='inboxscroll'>
                                                        {
                                                            typeof playerOutboxMessage.data != 'undefined' && playerOutboxMessage.data.length > 0 ? <>
                                                                {playerOutboxMessage.data.map((v, i) =>
                                                                    <tr key={i} style={{ background: 'var(--vs-card-bg2)', margin: "5px 0px" }}>
                                                                        <td className='note-player'>
                                                                            <label>
                                                                                <input type="checkbox" id="checkbor_arr_outbox" name="checkbor_arr_outbox" checked={multiCheckOutbox[v._id]} onChange={() => { }} onClick={() => { checkUnCheckMe(v._id, 'outbox') }} />
                                                                                <span></span>
                                                                            </label>
                                                                        </td>
                                                                        <tr className='democlass' onClick={() => replyMsg(v, 'outbox')}>
                                                                            <td className='zero'>{v.to_username}</td>
                                                                            <td className='subject-len'>{v.subject}</td>
                                                                        </tr>
                                                                        <tr className='democlass'>
                                                                            <td className='memodate' onClick={() => replyMsg(v, 'outbox')}>
                                                                                {formatDate(v?.created_at)}
                                                                            </td>
                                                                            <td className='memodate'>
                                                                                <span onClick={() => deleteMe('outbox', v?._id)}>
                                                                                    <RiDeleteBin6Line />
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tr>
                                                                )}
                                                            </> :
                                                                <>
                                                                    {props.t('no_memo_found')}
                                                                </>
                                                        }
                                                    </div>
                                                </tbody>
                                            }
                                        </table>
                                        {
                                            loading && <Loading />
                                        }
                                    </>
                            }
                        </div>
                    </div>
                </div>
                {sendMessage && <Popup handlePoup={handlePopup} sendEmail />}
                {durationPopup && <Popup handlePoup={handlePopup} handleEmailDurationPopupOn={handleEmailDurationPopupOn} message={waitMessage} sendEmailDuration />}
                {/* {unreadMessageCount > 0 && newMessageCount && <Popup handleNewMessageCount={handleNewMessageCount} count={unreadMessageCount} refreshInboxList={refreshInboxList} handlePoup={handlePopup} newMessageCount />} */}
                {showDelete && <Popup handlePoup={handlePopup} deleteMessageConfirm={deleteMessageConfirm} deleteConfirmMessage={deleteConfirmMessage} deleteMessagePopup />}
                {showWarning && <Popup handlePoup={handlePopup} warning />}
                {showSuccess && <Popup handlePoup={handlePopup} success />}
            </div >
        </>
    )
}

Notification.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Notification)